import Image from '@base/FutureImage';
import styled from '@emotion/styled';
import { Fonts, Spacings } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import AquillaButton from 'aquilla/core/molecules/Button';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const TopWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: ${Spacings.SPACING_6B};
  padding-bottom: ${Spacings.SPACING_10B};
`;

const TopDivider = styled.div`
  width: ${Spacings.SPACING_6B};
  height: ${Spacings.SPACING_2};
  border-radius: ${Spacings.SPACING_1};
  background-color: var(--color-text-secondary);
`;

const BottomDetailWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const BottomTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_6};
`;

const CtaWrapper = styled.div`
  padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_0B} ${Spacings.SPACING_0B};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: ${Spacings.SPACING_4B};
`;

const StyAquillaButton = styled(AquillaButton)<{ $border: boolean }>`
  height: ${Spacings.SPACING_12B};
  border-radius: ${Spacings.SPACING_2B};
  font-size: ${Fonts.H6};
  font-weight: ${Fonts.HEAVY};
  width: 100%;
  border: ${({ $border }) => $border && '1px solid var(--color-divider)'};
`;

const CancelPaymentComponent = ({
  handleLeftButtonClick,
  handleRightButtonClick,
  title,
  subTitle,
  imgSrc,
  imgAlt,
  leftButtonCta,
  leftButonType,
  rightButtonCta,
  rightButtonType
}) => {
  return (
    <Wrapper>
      <TopWrapper>
        <TopDivider />
      </TopWrapper>
      <BottomDetailWrapper>
        <BottomTextWrapper>
          <Typography variant="h3">{title}</Typography>
          <Typography variant="p2" color="#7A8B94">
            {subTitle}
          </Typography>
        </BottomTextWrapper>
        <Image src={imgSrc} alt={imgAlt} height={80} width={80} />
      </BottomDetailWrapper>
      <CtaWrapper>
        <StyAquillaButton
          variant={leftButonType}
          $border={leftButonType === 'ghost'}
          onClick={handleLeftButtonClick}
        >
          {leftButtonCta}
        </StyAquillaButton>
        <StyAquillaButton
          variant={rightButtonType}
          $border={rightButtonType === 'ghost'}
          onClick={handleRightButtonClick}
        >
          {rightButtonCta}
        </StyAquillaButton>
      </CtaWrapper>
    </Wrapper>
  );
};

export default CancelPaymentComponent;
